import { render, staticRenderFns } from "./DailymotionPlayer.vue?vue&type=template&id=e5473c80&scoped=true&"
import script from "./DailymotionPlayer.vue?vue&type=script&lang=js&"
export * from "./DailymotionPlayer.vue?vue&type=script&lang=js&"
import style0 from "./DailymotionPlayer.vue?vue&type=style&index=0&id=e5473c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5473c80",
  null
  
)

export default component.exports